import React from 'react';
import CSSModules from 'react-css-modules';
import * as PropTypes from 'prop-types';
import isNull from 'lodash/isNull';
import browserHistory from 'react-router/lib/browserHistory';
import Link from 'react-router/lib/Link';

import Button from '../../../Button';
import styles from './index.styl';

function ListWrapper({
  title,
  counter,
  onClick,
  children,
  actionText,
  buttonText,
  redirectTo,
  renderHeaderButton,
  onClickButton,
  additionalAction,
  renderAdditionalButton,
}) {
  const counterText = !isNull(counter) ? `(${counter})` : '';
  const handleClick = () => {
    additionalAction();
    browserHistory.push(redirectTo);
  };

  return (
    <div styleName="root">
      <div styleName="header">
        <div styleName="title">
          <h3 styleName="text">{`${title} ${counterText}`}</h3>
          {onClickButton ? (
            <Link to={redirectTo} onClick={onClickButton} styleName="link">
              {actionText}
            </Link>
          ) : (
            <div onClick={handleClick} styleName="link">
              {actionText}
            </div>
          )}
        </div>

        <If condition={Boolean(buttonText)}>
          <Button raised color="primary" onClick={onClick}>
            {buttonText}
          </Button>
        </If>

        <If condition={Boolean(renderHeaderButton) && !buttonText}>
          {renderHeaderButton()}
        </If>
      </div>
      <div styleName="content">{children}</div>
    </div>
  );
}

ListWrapper.defaultProps = {
  additionalAction: () => {},
};

ListWrapper.propTypes = {
  title: PropTypes.string,
  counter: PropTypes.number,
  onClick: PropTypes.func,
  children: PropTypes.node,
  redirectTo: PropTypes.string,
  actionText: PropTypes.string,
  buttonText: PropTypes.string,
  additionalAction: PropTypes.func,
  onClickButton: PropTypes.func,
  renderHeaderButton: PropTypes.func,
  renderAdditionalButton: PropTypes.node,
};

export default CSSModules(ListWrapper, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/ListWrapper/index.jsx